import styles from './swiperChangeLayout.module.css';
// import Swiper core and required modules
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectCreative,
} from 'swiper';

import DOMPurify from 'dompurify';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-creative';
import 'swiper/css/autoplay';

const SwiperChangeLayout = ({ subtitle, title, body, content = [], style }) => {
  const pagination = {
    clickable: true,
    // renderBullet: function (index, className) {
    //   return '<div class="' + className + '">' + (index + 1) + "</div>";
    // },
    renderBullet: function (index, className) {
      return `<div class="${className}">Tab${index}</div>`;
    },
  };
  return (
    <div className={styles.ctn} style={style}>
      <h6
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(subtitle),
        }}
      ></h6>
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_527_1214)">
          <path
            d="M8 8H29.3333V29.3333H8V8ZM8 34.6667H29.3333V56H8V34.6667ZM34.6667 34.6667H56V56H34.6667V34.6667Z"
            fill="#FF4D4D"
          />
          <path
            opacity="0.4"
            d="M45.4663 6.25385C45.7966 5.02736 47.5367 5.02736 47.8669 6.25385L49.4976 12.3102C49.7855 13.3797 50.6209 14.2151 51.6904 14.503L57.7468 16.1337C58.9732 16.4639 58.9732 18.2041 57.7468 18.5343L51.6904 20.1649C50.6209 20.4529 49.7855 21.2883 49.4976 22.3578L47.8669 28.4141C47.5367 29.6406 45.7966 29.6406 45.4663 28.4141L43.8357 22.3578C43.5477 21.2883 42.7123 20.4529 41.6429 20.1649L35.5865 18.5343C34.36 18.2041 34.36 16.4639 35.5865 16.1337L41.6429 14.503C42.7123 14.2151 43.5477 13.3797 43.8357 12.3102L45.4663 6.25385Z"
            fill="#FF4D4D"
          />
        </g>
        <defs>
          <clipPath id="clip0_527_1214">
            <rect width="64" height="64" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(title),
        }}
      ></h1>

      <h5
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(body),
        }}
      ></h5>
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        grabCursor={true}
        // pagination={{
        //   clickable: true,
        // }}
        loop={true}
        slidesPerView={1}
        speed={600}
        // onSlideChange={() => console.log("slide change")}
        // onSwiper={(swiper) => console.log(swiper)}
        className={styles.swiperBox}
        spaceBetween={24}
        navigation={{
          nextEl: '.swiper-next',
          prevEl: '.swiper-pre',
        }}
        breakpoints={{
          // when window width is >= 320px
          0: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          // when window width is >= 480px
          414: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          // when window width is >= 640px
          1024: {
            slidesPerView: 1,
            spaceBetween: 48,
          },
        }}
      >
        {content.map((item) => {
          return (
            <SwiperSlide>
              <div className={styles.mediaBox}>
                <img src={item.img} />
              </div>

              {/* <div
                className={styles.swiperItemText}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.text),
                }}
              ></div> */}
            </SwiperSlide>
          );
        })}
        <div className="swiper-pre">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5947 32L3.99988 20M3.99988 20L16.5947 8M3.99988 20L36.0001 20"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </div>

        <div className="swiper-next">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5947 32L3.99988 20M3.99988 20L16.5947 8M3.99988 20L36.0001 20"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </div>
      </Swiper>
      <div></div>
    </div>
  );
};

export default SwiperChangeLayout;
